import { render, staticRenderFns } from "./RaddarChart.vue?vue&type=template&id=56895f1e"
import script from "./RaddarChart.vue?vue&type=script&lang=js"
export * from "./RaddarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56895f1e')) {
      api.createRecord('56895f1e', component.options)
    } else {
      api.reload('56895f1e', component.options)
    }
    module.hot.accept("./RaddarChart.vue?vue&type=template&id=56895f1e", function () {
      api.rerender('56895f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/charts/RaddarChart.vue"
export default component.exports